import React, { Component, Fragment } from "react";
import { Button } from "../components/Button";
import { Paging } from "../components/Paging";
import { Table, TableHead, TableBody, Col, HeaderCell } from "../components/Table";
import { LoadingSpinner } from "../components/LoadingSpinner";
import "./SearchResults.css";
import "font-awesome/css/font-awesome.min.css";
import { FormattedMessage } from "react-intl";
import MunicipalityContext from "../MunicipalityContext";

export class SearchResults extends Component {
  static contextType = MunicipalityContext;

  render() {
    const {
      locale,
      changePage,
      currentPage,
      pageSize,
      results,
      searching,
      searchError,
      sortColumn,
      sortDirection,
      totalRows,
      updateSort,
    } = this.props;

    const spinner = (
      <div className='spinnerContainer'>
        <LoadingSpinner />
      </div>
    );
    if (!searching && !results) return "";

    if (searchError) {
      return (
        <div className='searchError'>
          <FormattedMessage id={`operatorSearch.error${searchError}`} />
        </div>
      );
    }

    const municipalities = this.context;

    const municipalityNames = municipalities.reduce((obj, municipality) => {
      obj[municipality.kuntaKoodi] =
        locale === "fi" ? municipality.kuntaNimi : municipality.kuntaNimiSv;
      return obj;
    }, {});

    const paging = (
      <Paging
        itemsLength={totalRows}
        perPage={pageSize}
        activePage={currentPage}
        changePage={changePage}
      >
        {({ totalPages, activePage, goBack, goForward }) => (
          <div className='paging'>
            <Button link onClick={goBack} disabled={activePage === 0}>
              <FormattedMessage id='common.previous' />
            </Button>
            <div className='pagesCount'>
              {activePage + 1} / {totalPages || 1}
            </div>
            <Button link onClick={goForward} disabled={activePage >= totalPages - 1}>
              <FormattedMessage id='common.next' />
            </Button>
          </div>
        )}
      </Paging>
    );

    const drawResultsHeadingFinished = (
      <div className="resultHeading" aria-live="assertive">
        <FormattedMessage
          id="common.results"
          values={{
            results: <span className="resultCount">{totalRows}</span>,
          }}
        />
      </div>
    );

    const drawResultsHeadingSearching = (
      <div className='resultHeading'>
        <FormattedMessage id='common.searching' />
      </div>
    );

    const drawDateOfExpiryIfExists = timestamp => {
      if (timestamp) {
        const date = new Date(timestamp);
        return date.toLocaleDateString("fi-FI");
      }
      return <FormattedMessage id='common.forNow' />;
    };

    const permitnumberUnknownText = locale === "fi" ? "Voimassa" : "Giltig";

    return (
      <Fragment>
        {searching ? drawResultsHeadingSearching : drawResultsHeadingFinished}
        {paging}
        <Table>
          <TableHead sortColumn={sortColumn} sortDirection={sortDirection} updateSort={updateSort}>
            <HeaderCell name='nimi'>
              <FormattedMessage id='operatorSearch.operator' />
            </HeaderCell>
            <HeaderCell name='vastuuhenkilo'>
              <FormattedMessage id='common.leader' />
            </HeaderCell>
            <HeaderCell name='toimintaoikeus'>
              <FormattedMessage id='common.competency' />
            </HeaderCell>
            <HeaderCell name='kuntaKoodi'>
              <FormattedMessage id='common.municipality' />
            </HeaderCell>
            <HeaderCell name='voimassaolopvm'>
              <FormattedMessage id='common.validityEnd' />
            </HeaderCell>
            <HeaderCell name='asiakasnro'>
              <FormattedMessage id='common.customerNumber' />
            </HeaderCell>
            <HeaderCell name='diaarinumero'>
              <FormattedMessage id='common.permitNumber' />
            </HeaderCell>
            <th />
          </TableHead>
          {searching ? (
            <tbody>
              <tr>
                <td colSpan='5'>{spinner}</td>
              </tr>
            </tbody>
          ) : (
            <TableBody rows={results}>
              {rows =>
                rows.map(row => {
                  const key = `${row.asiakasnro}${row.toimintaoikeus}`;
                  return (
                    <tr key={key}>
                      <Col label='operatorSearch.operator'>
                        {row.yTunnus} {row.nimi}
                        {row.toimipaikka && (
                          <small>
                            <br />
                            {row.toimipaikka}
                          </small>
                        )}
                      </Col>
                      <Col label='common.leader'>
                        {row.vastuuhenkilo}
                      </Col>
                      <Col label='common.competency'>
                        {row.toimintaoikeus}
                      </Col>
                      <Col label='common.municipality'>
                        {municipalityNames[row.kuntaKoodi]}
                      </Col>
                      <Col label='common.validUntil'>
                        {drawDateOfExpiryIfExists(row.voimassaolopvm)}
                      </Col>
                      <Col label='common.customerNumber'>
                        {row.asiakasnro || "-"}
                      </Col>
                      <Col label='common.permitNumber'>
                        {row.diaarinumero || permitnumberUnknownText}
                      </Col>
                    </tr>
                  );
                })
              }
            </TableBody>
          )}
        </Table>
        {paging}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/OperatorSearch/SearchResults.js